/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "../../../style/page.css";
import stages from "./Stages-of-work.css";
import f from '../../../style/foundation.min.css';
import {  LgScreen  } from 'react-responsive-redux';


const messages = defineMessages({
    stagesOfWorkTitle: {
        id: 'stages.stagesOfWorkTitle',
        defaultMessage: 'How we'
    },
    stagesOfWorkTitleBr: {
        id: 'stages.stagesOfWorkTitleBr',
        defaultMessage: 'do it'
    },
    stagesOfWorkText: {
        id: 'stages.stagesOfWorkText',
        defaultMessage: 'We carry out projects not only qualitatively and quickly, we do it with our soul. Turning to us, you yourself can contemplate as everyone, even the smallest task is a very important element in the overall process.'
    },
    stagesOfWorkItemText1: {
        id: 'stages.stagesOfWorkItemText1',
        defaultMessage: 'We agree on the'
    },
    stagesOfWorkItemTextBr1: {
        id: 'stages.stagesOfWorkItemTextBr1',
        defaultMessage: 'details and proposals'
    },
    stagesOfWorkItemText2: {
        id: 'stages.stagesOfWorkItemText2',
        defaultMessage: 'We carry out the whole'
    },
    stagesOfWorkItemTextBr2: {
        id: 'stages.stagesOfWorkItemTextBr2',
        defaultMessage: 'set of tasks for the project'
    },
    stagesOfWorkItemText3: {
        id: 'stages.stagesOfWorkItemText3',
        defaultMessage: 'We rent work and we are'
    },
    stagesOfWorkItemTextBr3: {
        id: 'stages.stagesOfWorkItemTextBr3',
        defaultMessage: 'happy together with the result'
    },
})

class StagesOfWork extends React.Component {
    constructor(props){
        super(props);
    }
    render() {
        let DATA = this.props.HOWWEDOIT;
        return (
            <div className={['edgtf-parallax-holder'] + " " + s.marginBlock} data-parallax="{&quot;y&quot;: -100, &quot;smoothness&quot;: 20}">
                <LgScreen>
                    <div className="edgtf-elements-holder   edgtf-one-column  edgtf-responsive-mode-768 ">
                        <div className="edgtf-eh-item" data-item-class="edgtf-eh-custom-8567" data-1024-1280="60px 0 148px 0">
                            <div className="edgtf-eh-item-inner">
                                <div className="edgtf-eh-item-content edgtf-eh-custom-8567">
                                    <div className={s.section}>
                                        <div className={stages.howBlock}>
                                            <div className={f.row + " " + stages.row}>
                                                <div className={f['large-12'] + " " + f['columns']}>
                                                    <h2 className={s.floatLeftBorder}><FormattedMessage {...messages[DATA.title]} /> <br /> <span><FormattedMessage {...messages[DATA.titleBr]} /></span></h2>
                                                    <p><FormattedMessage {...messages[DATA.text]} /></p>
                                                </div>
                                                <div className={f['large-12'] + " " + f['columns'] + " " + stages['columns']}>
                                                    {DATA.ITEMS.map((item, index) => {
                                                        return (
                                                            <div key={index} className={stages.howImg}>
                                                                <div className={stages.contentBlock + " " + stages[item.class]}>
                                                                    <img src={item.imgUrl} alt="how"/>
                                                                    <p><FormattedMessage {...messages[item.text]} /><br /> <FormattedMessage {...messages[item.textBr]} /></p>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </LgScreen>
            </div>
        );
    }
}

export default injectIntl(
    compose(
        withStyles(s, stages, f),
        connect(
            state => ({
            HOWWEDOIT: state.dataRu.HOWWEDOIT
        }),
        dispatch => ({})
)
)(StagesOfWork));
